// extracted by mini-css-extract-plugin
export default {"cls1":"U9g9FfUcg5zNQfP2Nr7U","cls2":"KyL22fcETXb_rzwUmuAo U9g9FfUcg5zNQfP2Nr7U"};